var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "filter-default",
        {
          attrs: { options: _vm.options, requests: "" },
          model: {
            value: _vm.filters,
            callback: function ($$v) {
              _vm.filters = $$v
            },
            expression: "filters",
          },
        },
        [
          _c("div", { staticClass: "column is-narrow pt-1 pb-1" }, [
            _c(
              "div",
              { staticClass: "flatpickr-combined" },
              [
                _c("async-select", {
                  staticClass: "is-smaller",
                  attrs: {
                    api: "ports",
                    placeholder: "Abfahrtsbahnhof",
                    "custom-label": (port) => port.name,
                  },
                  model: {
                    value: _vm.filters.train.startTrainStation,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters.train, "startTrainStation", $$v)
                    },
                    expression: "filters.train.startTrainStation",
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("-")]),
                _vm._v(" "),
                _c("async-select", {
                  staticClass: "is-smaller",
                  attrs: {
                    api: "ports",
                    placeholder: "Ankunftsbahnhof",
                    "custom-label": (port) => port.name,
                  },
                  model: {
                    value: _vm.filters.train.endTrainStation,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters.train, "endTrainStation", $$v)
                    },
                    expression: "filters.train.endTrainStation",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }